import { render } from "./App.vue?vue&type=template&id=3dc6587e"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=3dc6587e&lang=scss"

import exportComponent from "D:\\work\\jp\\cbredata\\creis_develop\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__